import {useRef} from 'react';
import {observer} from 'mobx-react';
import {useDrag, useDrop} from 'react-dnd';
import { v4 as uuidv4 } from 'uuid';
import FormError from 'shared/components/FormError';
import {FormattedMessage} from 'react-intl';

const type = uuidv4();

const DraggableItem = observer(({model, uiState, errorMessage, children}) => {
  const containerRef = useRef(null);
  const handleRef = useRef(null);

  const [, connectDrag, connectDragPreview] = useDrag({
    type,
    item: () => ({index: uiState.sortedModels.indexOf(model)})
  });

  const [{isOver}, connectDrop] = useDrop({
    accept: type,
    collect: monitor => ({isOver: monitor.isOver()}),
    hover(item) {
      const dragIndex = item.index;
      const hoverIndex = uiState.sortedModels.indexOf(model);

      if (dragIndex === hoverIndex) return;

      uiState.moveModel(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  });

  connectDragPreview(connectDrop(containerRef));
  connectDrag(handleRef);

  return (
    <div className='col-12 mb2 HoverAnimation-trigger relative'>
      {model.color && <div className='absolute full-height left-0 rounded-left' style={{backgroundColor: model.color, width: 12}}/>}
      <div ref={containerRef} className={`py1 bg-white border rounded clickable ${isOver ? 'is-over' : ''}`}>
        <div className='clearfix table'>
          <div ref={handleRef} className='col-1 table-cell align-middle center px2'>
            <i className='material-symbols-solid submarine pt1'>{'drag_handle'}</i>
          </div>
          <div className={`col-${uiState.hasLinks ? '10' : '11'} table-cell align-middle`}>
            {children}
          </div>
          {(uiState.hasLinks) && <div className='table-cell col-1 align-middle center'>
            <div className='px1 dropdown inline-block px2'>
              <i className='HoverAnimation-trigger--image material-symbols-solid submarine align-top' data-toggle='dropdown'>{'more_horiz'}</i>
              <ul className='dropdown-menu right-0'>
                {uiState.onEdit && <li><a href='#' className='py1 px2 regular jumbo' onClick={() => uiState.editModel(model)}>
                  <FormattedMessage id='Edit'/>
                </a></li>}
                {uiState.onDuplicate && <li><a href='#' className='py1 px2 regular jumbo' onClick={() => uiState.duplicateModel(model)}>
                  <FormattedMessage id='Duplicate'/>
                </a></li>}
                {uiState.onRemove && model.isRemovable !== false && <li><a href='#' className='py1 px2 regular jumbo' onClick={() => uiState.removeModel(model)}>
                  <FormattedMessage id='Delete'/>
                </a></li>}
              </ul>
            </div>
          </div>}
        </div>
        <div className='ml2'>
          <FormError message={errorMessage} />
        </div>
      </div>
    </div>
  );
});

export default DraggableItem;
